import classNames from "classnames";
import React from "react";
import { VerticalNavigationContext } from "./vertical-navigation-context";

type BaseVerticalNavigationProps = {
  ariaLabel?: string;
  children: React.ReactNode;
  className?: string;
  collapse?: boolean;
};

export const BaseVerticalNavigation: React.FC<BaseVerticalNavigationProps> = ({
  ariaLabel = "VerticalNavigation menu bar",
  children,
  className = "",
  collapse = false
}: BaseVerticalNavigationProps) => {
  const classes = classNames({
    "motif-vertical-navigation": true,
    "motif-vertical-navigation-expanded-width": !collapse,
    "motif-vertical-navigation-collapsed": collapse,
    [className]: true
  });

  return (
    <VerticalNavigationContext.Provider
      value={{ collapse, rootClassName: className }}
    >
      <nav
        className={classes}
        aria-label={ariaLabel}
        data-motif-vertical-navigation
      >
        {children}
      </nav>
    </VerticalNavigationContext.Provider>
  );
};
